export enum VideoRecordingEvent {
	OpenModal = 'open-video-recording-modal',
	AttachToBonus = 'attach-to-bonus',
	DestroyRecording = 'destroy-recording',
	ClosedCarouselModalWithNoVideo = 'closed-carousel-modal-with-no-video',
}

export enum TrackerVideoEvent {
	videoRecordingModalOpen = 'video-open-recording-modal',
	videoRecordStart = 'video-record-start',
	videoAttachToBonus = 'video-attach-to-bonus',
	videoRecordingModalClose = 'video-recording-abandoned',
	videoBonusUnmute = 'video-bonus-unmute',
	VideoBonusPlay = 'video-bonus-play',
	videoBonusPause = 'video-bonus-pause',
	videoBonusEnd = 'video-bonus-end',
	videoBonusView = 'video-bonus-view',
}
